var _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCoverimage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.83331 7.16406C6.38531 7.16406 6.83331 6.71606 6.83331 6.16406C6.83331 5.61206 6.38531 5.16406 5.83331 5.16406C5.28131 5.16406 4.83331 5.61206 4.83331 6.16406C4.83331 6.71606 5.28131 7.16406 5.83331 7.16406ZM12.5 13.1651H4.87402L9.54402 9.2684C9.70802 9.12906 10.0054 9.12973 10.166 9.26773L13.1667 11.8277V12.4984C13.1667 12.8664 12.868 13.1651 12.5 13.1651ZM4.49998 3.83594H12.5C12.868 3.83594 13.1666 4.1346 13.1666 4.5026V10.0786L11.0313 8.25727C10.3713 7.69594 9.33865 7.69594 8.68465 8.25327L3.83331 12.3013V4.5026C3.83331 4.1346 4.13198 3.83594 4.49998 3.83594ZM12.5 2.5H4.5C3.39733 2.5 2.5 3.39733 2.5 4.5V12.5C2.5 13.6027 3.39733 14.5 4.5 14.5H12.5C13.6027 14.5 14.5 13.6027 14.5 12.5V4.5C14.5 3.39733 13.6027 2.5 12.5 2.5Z",
    fill: "#231F20"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5950_45260",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 13,
    height: 13
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.83331 7.16406C6.38531 7.16406 6.83331 6.71606 6.83331 6.16406C6.83331 5.61206 6.38531 5.16406 5.83331 5.16406C5.28131 5.16406 4.83331 5.61206 4.83331 6.16406C4.83331 6.71606 5.28131 7.16406 5.83331 7.16406ZM12.5 13.1651H4.87402L9.54402 9.2684C9.70802 9.12906 10.0054 9.12973 10.166 9.26773L13.1667 11.8277V12.4984C13.1667 12.8664 12.868 13.1651 12.5 13.1651ZM4.49998 3.83594H12.5C12.868 3.83594 13.1666 4.1346 13.1666 4.5026V10.0786L11.0313 8.25727C10.3713 7.69594 9.33865 7.69594 8.68465 8.25327L3.83331 12.3013V4.5026C3.83331 4.1346 4.13198 3.83594 4.49998 3.83594ZM12.5 2.5H4.5C3.39733 2.5 2.5 3.39733 2.5 4.5V12.5C2.5 13.6027 3.39733 14.5 4.5 14.5H12.5C13.6027 14.5 14.5 13.6027 14.5 12.5V4.5C14.5 3.39733 13.6027 2.5 12.5 2.5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5950_45260)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 16,
    height: 16,
    fill: "#0D1C2E"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoverimage);
export default __webpack_public_path__ + "static/media/Coverimage.d1a22d74ffe364cf0fab57833158d718.svg";
export { ForwardRef as ReactComponent };